import { closeSnackbar, CustomContentProps } from 'notistack';
import React, { useCallback } from 'react';

import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import useStyles from './styles';

const SnackbarWithLinks = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { id, message } = props;
  const classes = useStyles();
  const messageText = (message as string) || '';
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = messageText.split(urlRegex);

  const handleClose = useCallback(() => {
    closeSnackbar(id);
  }, [id]);

  const renderMessageWithLinks = (): React.ReactNode => {
    return parts.map((part, index) => {
      const isUrl = /^https?:\/\/[^\s]+$/.test(part);
      if (isUrl) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div ref={ref} className={classes.errorContainer} role="alert">
      <ErrorIcon className={classes.icon} onClick={handleClose} />
      <span className={classes.message}>{renderMessageWithLinks()}</span>
    </div>
  );
});

SnackbarWithLinks.displayName = 'SnackbarWithLinks';

export default SnackbarWithLinks;
